<template>
  <div class="upload-desc-wrap">
    <el-upload
      v-if="edit"
      ref="upload"
      class="upload-desc"
      :action="picUrl"
      accept="image/*"
      multiple
      :file-list="myList"
      :limit="20"
      :show-file-list="false"
      :http-request="uploadSectionFile"
      :on-exceed="handleDescExceed">
      <el-button
        size="small"
        type="primary">点击上传</el-button>
      <div
        slot="tip"
        class="el-upload__tip">上传图片不能超过 20张!已上传 <span style="color:#409EFF">{{ myList.length }}</span> 张</div>
    </el-upload>
    <div style="display:flex">
      <div
        class="detail-phone"
        style="flex: 0 0 188px;margin-right: 8px">
        <div class="phone-inner">
          <!-- <el-scrollbar wrap-class="scrollbar-wrap"
          :native="false"> -->
          <template v-for="(item, index) in myList">
            <img
              v-if="item.type === 'image'"
              :key="index"
              :src="item.url">
            <video
              v-else
              :key="index"
              style="width: 100%"
              controls
              :src="item.url">
            </video>
          </template>
        <!-- </el-scrollbar> -->
        </div>
      </div>
      <draggable
        v-if="edit"
        v-model="myList"
        class="el-upload-list el-upload-list--text"
        element="ul"
        style="flex: 1"
        :options="dragOptions">
        <li
          v-for="(item,index) in myList"
          :key="item.url"
          class="el-upload-list__item is-success"
          style="cursor: move;">
          <a class="el-upload-list__item-name">
            <i class="el-icon-rank"></i>
            <i class="el-icon-document"></i>{{ item.name | getFilename() }}
          </a>
          <label class="el-upload-list__item-status-label">
            <i class="el-icon-upload-success el-icon-circle-check"></i>
          </label>
          <i
            class="el-icon-close"
            @click="deleteDesc(item,index)"></i>
        </li>
      </draggable>
    </div>
  </div>
</template>

<script>
import { picUrl } from '../../service/common'
import draggable from 'vuedraggable'
// import _ from 'lodash'
export default {
  name: 'DescImagesNew',
  components: { draggable },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      picUrl,
      dragOptions: {
        animation: 0,
        disabled: false,
        group: 'description',
        ghostClass: 'ghost'
      }
    }
  },
  computed: {
    myList: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {},
  created() { },
  mounted() {
    // this.$dragging.$on('dragged', ({ value }) => {
    //   console.log(value.item)
    //   console.log(value.list)
    //   console.log(value.otherData)
    //   // console.log(this.value)
    //   let result = []
    //   value.list.forEach(item => {
    //     if (_.findIndex(this.value, o => o.url === item.url) > -1) {
    //       result.push(item)
    //     }
    //   })
    //   this.$emit('input', result)
    // })
  },
  methods: {
    uploadSectionFile({ file }) {
      const isLt = file.size / 1024 / 1024
      console.log('uploadSectionFile', file)
      if (file.type.indexOf('video') > -1 && isLt > 20) {
        this.$message.error('上传视频文件大小不能超过 20MB!')
        return
      }
      if (file.type.indexOf('image') > -1 && isLt > 2) {
        this.$message.error('上传图片文件大小不能超过 2MB!')
        return
      }
      this.uploadFile(file)
    },
    uploadFile(file) {
      const form = new FormData()
      form.append('file', file)
      this.$store.dispatch('account/uploadfile', {
        payload: form,
        success: res => {
          this.myList.push({
            url: res.data.viewUrl + res.data.filepath,
            name: file.name,
            type: file.type.indexOf('video') > -1 ? 'video' : 'image'
          })
        },
        fail: () => { }
      })
    },
    handleDescSuccess(res, file) {
      console.log('handleDescSuccess', file)
      console.log(JSON.stringify(this.$refs.upload.uploadFiles))
      this.$refs.upload.uploadFiles.forEach(item => {
        if (item.uid === file.uid) {
          item.url = res.viewUrl + res.filepath
          item.name = file.name
          item.type = file.raw.type.indexOf('video') > -1 ? 'video' : 'image'
        }
      })
      // let list = _.cloneDeep(this.value)
      // list.push({
      //   url: res.viewUrl + res.filepath,
      //   name: file.name
      // })
      // this.$emit('input', list)
      this.$emit('input', this.$refs.upload.uploadFiles)
    },
    handleDescExceed(files, fileList) {
      this.$message.warning(`当前限制选择 20 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    deleteDesc(item, index) {
      // console.log('111111')
      // let list = _.cloneDeep(this.value)
      // list.splice(index, 1)
      // this.$emit('input', list)
      this.myList.splice(index, 1)
    }
  }
}
</script>
<style lang="stylus">
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.upload-desc-wrap {
  .upload-desc {
    .el-upload-list {
      display: none;
    }
  }

  .el-upload-list__item-name, .el-upload-list__item-name * {
    cursor: grab !important;
  }

  .detail-phone {
    margin: 10px 0 0;
    width: 188px;
    height: 334px;
    border: 1px solid #454553;
    background: url('../../assets/images/mobi.png') left top / 188px 334px no-repeat;

    .phone-inner {
      width: 100%;
      height: calc(100% - 32px);
      margin-top: 32px;
      overflow: auto;

      img {
        max-width: 100%;
        vertical-align: top;
      }
    }
  }
}
</style>
